// ManagerDashboard - Wrapper for the new OperationsDashboard
// The old mock-data dashboard has been replaced with the live Operations Dashboard

import { OperationsDashboard } from './OperationsDashboard';

export function ManagerDashboard() {
  return <OperationsDashboard />;
}
